import $ from 'jquery'
document.addEventListener('turbo:load', () => {
  $('#js-buyer-terms-of-acquisition-modal').modal({ backdrop: 'static', show: true })
})
